<template>
    <div>
        <PullContainer ref="pullContainerRef" :pullDownLoading="true" :pullDownLabel="true" @pullDownLoadingSuccess="pullDownLoadingSuccess">
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
                        <div class="returnNavBarRight" v-if="!isCardEdit">
                            <span @click="handleClickCardEdit">编辑卡片</span>
                        </div>
                    </div>
                    <div class="mobile_container finance_management_container">
                        <div>
                            <template v-if="isCardEdit">
                                <div class="card_edit_btn">
                                    <van-button type="default" size="mini" @click="handleClickCardAdd">添加</van-button>
                                    <van-button type="info" size="mini" @click="handleClickCardEditFinish">完成</van-button>
                                </div>
                            </template>
                            <template v-else>
                                <div class="finance_top_card">
                                    <ul>
                                        <li>
                                            <p>
                                                <span>应付</span><img src="https://download.hecoos.com/enlightv/2025-06/075412799ccae7aa982b390754a65140.png" alt="" />
                                            </p>
                                            <p>待付款</p>
                                            <p class="count">{{ dashboardData.payable_pending_count || 0}}</p>
                                        </li>
                                        <li>
                                            <p>
                                                <span>应收</span><img src="https://download.hecoos.com/enlightv/2025-06/2a0e8b0b47f90d48f4fa1d87980ea7d5.png" alt="" />
                                            </p>
                                            <p>待确定</p>
                                            <p class="count">{{ dashboardData.receivable_pending_count || 0 }}</p>
                                        </li>
                                        <li>
                                            <p>
                                                <span>开票</span><img src="https://download.hecoos.com/enlightv/2025-06/0bd3ae962ebe1c10521133093cad8bd1.png" alt="" />
                                            </p>
                                            <p>待确定</p>
                                            <p class="count">{{ dashboardData.invoice_pending_count || 0 }}</p>
                                        </li>
                                    </ul>
                                </div>
                                <div class="finance_filter">
                                    <div class="finance_filter_left">
                                        <span v-for="item in filterTabTypeList" :key="item.type" :class="{ active: item.type === filterTabType }"
                                            @click="handleClickFilterTabChange(item)">{{ item.name }}</span>
                                    </div>
                                    <div class="finance_filter_right" @click="timeRadioPicker = true">
                                        <span v-text="timeTypeList.find((item) => item.value === filterTimeType).name"></span>
                                        <i class="el-icon-caret-bottom"></i>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <template v-if="filterTabType == 'payable'">
                            <template v-for="item in payableTabList">
                                <div class="card_item" v-if="item.source_type == 'payableSummary'">
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>应付汇总金额</p>
                                            <p>
                                                {{
                                                    summaryData.summary_data &&
                                                    summaryData.summary_data.total_payable_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>已付汇总金额</p>
                                            <p>
                                                {{
                                                    summaryData.summary_data &&
                                                    summaryData.summary_data.total_paid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>应付未付汇总金额</p>
                                            <p>
                                                {{
                                                    summaryData.summary_data &&
                                                    summaryData.summary_data.total_unpaid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>取消汇总金额</p>
                                            <p>
                                                {{
                                                    summaryData.summary_data &&
                                                    summaryData.summary_data.total_canceled_amount
                                                }}元
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container7"></div>
                                    </div>
                                    <div class="chart_box pie_chart_box">
                                        <div class="echarts_container" id="container8"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                                <div class="card_item" v-else-if="item.source_type == 'purchase'">
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>采购应付总金额</p>
                                            <p>
                                                {{
                                                    payable_purchase_summaryData.summary_data &&
                                                    payable_purchase_summaryData.summary_data.total_payable_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>采购已付总金额</p>
                                            <p>
                                                {{
                                                    payable_purchase_summaryData.summary_data &&
                                                    payable_purchase_summaryData.summary_data.total_paid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>采购未付总金额</p>
                                            <p>
                                                {{
                                                    payable_purchase_summaryData.summary_data &&
                                                    payable_purchase_summaryData.summary_data.total_unpaid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>取消总金额</p>
                                            <p>
                                                {{
                                                    payable_purchase_summaryData.summary_data &&
                                                    payable_purchase_summaryData.summary_data.total_canceled_amount
                                                }}元
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container9"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                                <div class="card_item" v-else-if="item.source_type == 'order_return'">
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>订单退款应付总金额</p>
                                            <p>
                                                {{
                                                    payable_order_return_summaryData.summary_data &&
                                                    payable_order_return_summaryData.summary_data.total_payable_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>订单退款已付总金额</p>
                                            <p>
                                                {{
                                                    payable_order_return_summaryData.summary_data &&
                                                    payable_order_return_summaryData.summary_data.total_paid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>订单退款未付总金额</p>
                                            <p>
                                                {{
                                                    payable_order_return_summaryData.summary_data &&
                                                    payable_order_return_summaryData.summary_data.total_unpaid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>订单退款取消总金额</p>
                                            <p>
                                                {{
                                                    payable_order_return_summaryData.summary_data &&
                                                    payable_order_return_summaryData.summary_data.total_canceled_amount
                                                }}元
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container10"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                                <div class="card_item" v-else>
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>{{ item.chartTooltipTitle }}应付总金额</p>
                                            <p>
                                                {{
                                                    item.summaryData &&
                                                    item.summaryData.summary_data &&
                                                    item.summaryData.summary_data.total_payable_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>{{ item.chartTooltipTitle }}已付总金额</p>
                                            <p>
                                                {{
                                                    item.summaryData &&
                                                    item.summaryData.summary_data &&
                                                    item.summaryData.summary_data.total_paid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>{{ item.chartTooltipTitle }}未付总金额</p>
                                            <p>
                                                {{
                                                    item.summaryData &&
                                                    item.summaryData.summary_data &&
                                                    item.summaryData.summary_data.total_unpaid_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>{{ item.chartTooltipTitle }}取消总金额</p>
                                            <p>
                                                {{
                                                    item.summaryData &&
                                                    item.summaryData.summary_data &&
                                                    item.summaryData.summary_data.total_canceled_amount
                                                }}元
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" :id="'container' + Number(10 + item.id)"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <template v-for="item in receivableTabList">
                                <div class="card_item" v-if="item.source_type == 'receivableSummary'">
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>应收待确认汇总金额</p>
                                            <p>
                                                {{
                                                    summaryData.summary_data &&
                                                    summaryData.summary_data.pending_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>应收已确认汇总金额</p>
                                            <p>
                                                {{
                                                    summaryData.summary_data &&
                                                    summaryData.summary_data.confirmed_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>应收已驳回汇总金额</p>
                                            <p>
                                                {{
                                                    summaryData.summary_data &&
                                                    summaryData.summary_data.rejected_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container1"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                                <div class="card_item" v-else-if="item.source_type == 'orderRefund'">
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>订单回款待确认总金额</p>
                                            <p>
                                                {{
                                                    receivable_orderRefund_summaryData.summary_data &&
                                                    receivable_orderRefund_summaryData.summary_data
                                                        .pending_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>订单回款已确认总金额</p>
                                            <p>
                                                {{
                                                    receivable_orderRefund_summaryData.summary_data &&
                                                    receivable_orderRefund_summaryData.summary_data
                                                        .confirmed_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>订单回款已驳回总金额</p>
                                            <p>
                                                {{
                                                    receivable_orderRefund_summaryData.summary_data &&
                                                    receivable_orderRefund_summaryData.summary_data
                                                        .rejected_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container3"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                                <div class="card_item" v-else-if="item.source_type == 'purchase'">
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>采购退款待确认总金额</p>
                                            <p>
                                                {{
                                                    receivable_purchase_summaryData.summary_data &&
                                                    receivable_purchase_summaryData.summary_data
                                                        .pending_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                        <li>
                                            <p>采购退款已确认总金额</p>
                                            <p>
                                                {{
                                                    receivable_purchase_summaryData.summary_data &&
                                                    receivable_purchase_summaryData.summary_data
                                                        .confirmed_confirmation_amount
                                                }}元
                                            </p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container4"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                                <div class="card_item" v-else-if="item.source_type == 'unRefund'">
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>未回款总金额</p>
                                            <p>{{ receivable_unRefund_summaryData.total_unpaid_amount }}元</p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container5"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                                <div class="card_item" v-else>
                                    <ul class="finance_statistics_num">
                                        <li>
                                            <p>坏账总金额</p>
                                            <p>{{ receivable_badDebt_summaryData.total_bad_debt_amount }}元</p>
                                        </li>
                                    </ul>
                                    <div class="chart_box">
                                        <div class="chart_box_time_type">
                                            <span v-for="typeItem in chartDateTypeList" :key="typeItem.type" :class="{ active: chartDateType === typeItem.type }"
                                                @click="handleClickChartType(typeItem.type, item)">{{ typeItem.name }}</span>
                                        </div>
                                        <div class="echarts_container" id="container6"></div>
                                    </div>
                                    <div class="card_item_mark" v-if="isCardEdit">
                                        <i class="iconfont icon-jianqu"></i>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                    <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" v-if="timeRadioPicker" :show="timeRadioPicker">
                        <div class="custome_radio_option_wrap">
                            <ul class="radio_option_list">
                                <li v-for="item in timeTypeList" class="radio_option_item" @click="handleClickTimeOption(item)" v-text="item.name"></li>
                            </ul>
                            <div class="cancel_btn" @click="timeRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>
                    <van-popup v-model="setPopupVisible" position="bottom" :style="{ height: '70%' }" :overlay="false" class="set_popup">
                        <div class="set_popup_wrap">
                            <div class="set_popup_title">
                                <van-search v-model="searchForm.keyword" placeholder="搜索组件" @clear="handleClickSearch" @search="handleClickSearch">
                                </van-search>
                                <van-button plain type="info">确定</van-button>
                            </div>
                            <div class="set_popup_content">
                                <div class="set_popup_card set_popup_card_added">
                                    <p class="set_item_title">已添加看板</p>
                                    <ul>
                                        <li v-for="item in payableTabList">
                                            <p>{{ item.label }}</p>
                                            <span class="card_item_btn">移除</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="set_popup_card set_popup_card_un_add">
                                    <p class="set_item_title">看板类型</p>
                                    <ul>
                                        <li v-for="item in payableTabList">
                                            <p>{{ item.label }}</p>
                                            <span class="card_item_btn">添加</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </van-popup>
                </div>
            </template>
        </PullContainer>
    </div>
</template>
<script>
import * as echarts from "echarts";
import { getDateRange, formatDate } from "@/utils";
import {
    PayableDashboard,
    PayableSourceList,
    PayablePurchaseSummary,
    PayableOrderRefundSummary,
    PayableApprovalSummary,
    PayableSummary,
    BadDebtSummary,
    UnpaidSummary,
    OrderRepaySummary,
    PurchaseRefundSummary,
    ReceivableSummary,
} from "@/api";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
export default {
    name: "FinanceManagement",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
    },
    data() {
        return {
            dashboardData: {
                invoice_pending_count: 0,
                payable_pending_count: 0,
                receivable_pending_count: 0
            },
            filterTabType: "payable",
            filterTimeType: "month",
            filterTabTypeList: [
                { type: "payable", name: "应付看板" },
                { type: "receivable", name: "应收看板" },
            ],
            searchForm: {
                keyword: "",
                date_range: "",
            },
            timeTypeList: [
                { value: "month", name: "本月" },
                { value: "quarter", name: "本季度" },
                { value: "year", name: "本年" },
                { value: "custom", name: "自定义" },
            ],
            timeRadioPicker: false,
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "FinanceManagement",
                    title: "首页",
                },
                {
                    icon: "icon-mobile-yingfu",
                    activeIcon: "icon-mobile-yingfu",
                    routerName: "PayableManage",
                    title: "应付",
                },
                {
                    icon: "icon-yingshou",
                    activeIcon: "icon-yingshouxuanzhong",
                    routerName: "ReceivableManage",
                    title: "应收",
                },
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "InvoiceManage",
                    title: "开票",
                },
            ],
            tabBarActive: 0,
            // 图表展示时间类型切换
            chartDateType: "day",
            chartDateTypeList: [
                { name: "日", type: "day" },
                { name: "周", type: "week" },
                { name: "月", type: "month" },
            ],
            // 统计数据
            summaryData: {
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
                pie_data: [],
            },
            payable_purchase_summaryData: {
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
                pie_data: [],
            },
            payable_order_return_summaryData: {
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
                pie_data: [],
            },
            payableTabList: [],
            // 应收数据
            receivable_orderRefund_summaryData: {
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
            },
            receivable_purchase_summaryData: {
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
            },
            receivable_unRefund_summaryData: {
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
            },
            receivable_badDebt_summaryData: {
                summary_data: {
                    pending_confirmation_amount: "",
                    confirmed_confirmation_amount: "",
                    rejected_confirmation_amount: "",
                },
                trend_data: [], // 图表数据
                list_data: [], // 表格数据
            },
            receivableTabList: [
                {
                    source_type: "receivableSummary",
                    label: "应收汇总统计",
                },
                {
                    source_type: "orderRefund",
                    label: "订单回款应收统计",
                },
                {
                    source_type: "purchase",
                    label: "采购退款应收统计",
                },
                {
                    source_type: "unRefund",
                    label: "未回款统计",
                },
                {
                    source_type: "badDebt",
                    label: "坏账款项统计",
                },
            ],
            isCardEdit: false, // 是否编辑卡片
            setPopupVisible: false, // 设置卡片弹框
        };
    },
    created() {
        const end = new Date();
        const start = new Date(end.getFullYear(), end.getMonth(), 1);
        this.searchForm.date_range = [formatDate(start, "date"), formatDate(end, "date")];
        this.getPayableDashboard();
        this.getPayableSourceList();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                setTimeout(() => {
                    this.$refs.pullContainerRef.pullDownLoadingEnd();
                }, 3000);
            }
        },
        handleClickTimeOption(item) {
            if (item.value == "custom") {
            } else {
                this.searchForm.date_range = getDateRange(item.value).split(" - ");
                this.handleClickSearch();
            }
            this.filterTimeType = item.value;
            this.timeRadioPicker = false;
        },
        // 图表日期类型切换
        handleClickChartType(type) {
            this.chartDateType = type;
        },
        // 获取统计数
        getPayableDashboard() {
            PayableDashboard().then(res=> {
                if(res.code === 200) {
                    this.dashboardData = res.data || {}
                }
            })
        },
        // 应付来源
        getPayableSourceList() {
            PayableSourceList().then((res) => {
                if (res.code === 200) {
                    let data = res.data || [];
                    if (data.length) {
                        let payableTabList = [
                            {
                                source_type: "payableSummary",
                                name: "payableSummary",
                                label: "应付汇总统计",
                            },
                        ];
                        const tabData = data.map((item) => {
                            return {
                                source_type: item.source_type,
                                name: item.source_type == "approval" ? item.source_type + item.id : item.source_type,
                                label: item.name + "统计",
                                chartTitle:
                                    item.source_type == "purchase"
                                        ? "采购应付金额趋势"
                                        : item.source_type == "order_return"
                                            ? "订单退款应付金额趋势"
                                            : item.name + "应付金额",
                                chartTooltipTitle: item.name,
                                id: item.id,
                                summaryData: {
                                    summary_data: {},
                                    trend_data: [], // 图表数据
                                    list_data: [], // 表格数据
                                    pie_data: [], // 饼图
                                },
                            };
                        });
                        this.payableTabList = payableTabList.concat(tabData);
                    }
                    this.$nextTick(() => {
                        this.handleClickSearch();
                    });
                }
            });
        },
        // 类型tab切换
        handleClickFilterTabChange(item) {
            this.filterTabType = item.type;
            this.handleClickSearch();
        },
        handleClickSearch() {
            if (this.filterTabType == "payable") {
                this.payableTabList.forEach((item) => {
                    if (item.source_type == "payableSummary") {
                        this.getPayableSummary();
                    } else if (item.source_type == "purchase") {
                        this.getPayablePurchaseSummary(item.id);
                    } else if (item.source_type == "order_return") {
                        this.getPayableOrderRefundSummary(item.id);
                    } else {
                        // this.getPayableApprovalSummary(item.id, item.chartTooltipTitle, 'payable_' + item.source_type + '_summaryData' + item.id, "container" + Number(10 + item.id))
                        this.getPayableApprovalSummary(
                            item.id,
                            item.chartTooltipTitle,
                            item,
                            "container" + Number(10 + item.id)
                        );
                    }
                });
            } else {
                this.getReceivableSummary();
                this.getOrderRepaySummary();
                this.getPurchaseRefundSummary();
                this.getUnpaidSummary();
                this.getBadDebtSummary();
            }
        },
        // 应付汇总
        getPayableSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            PayableSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "汇总金额", "container7");
                    this.getPieData(this.summaryData.pie_data, "container8");
                }
            });
        },
        // 采购应付统计
        getPayablePurchaseSummary(source_id) {
            const params = {
                source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            PayablePurchaseSummary(params).then((res) => {
                if (res.code === 200) {
                    this.payable_purchase_summaryData = res.data || {};
                    this.getBarData(this.payable_purchase_summaryData.trend_data, "采购应付金额", "container9");
                }
            });
        },
        // 订单退款应付统计
        getPayableOrderRefundSummary(source_id) {
            const params = {
                source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            PayableOrderRefundSummary(params).then((res) => {
                if (res.code === 200) {
                    this.payable_order_return_summaryData = res.data || {};
                    this.getBarData(
                        this.payable_order_return_summaryData.trend_data,
                        "订单退款应付金额",
                        "container10"
                    );
                }
            });
        },
        // 应付控件组统计
        getPayableApprovalSummary(source_id, chartTooltipTitle, dataName, containerId) {
            const params = {
                source_id,
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            PayableApprovalSummary(params).then((res) => {
                if (res.code === 200) {
                    // this[dataName] = res.data || {};
                    // this.getBarData(this[dataName].trend_data, chartTooltipTitle + "应付金额", containerId);
                    this.$set(dataName, "summaryData", res.data || {});
                    this.getBarData(res.data && res.data.trend_data, chartTooltipTitle + "应付金额", containerId);
                }
            });
        },
        // 应收汇总
        getReceivableSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            ReceivableSummary(params).then((res) => {
                if (res.code === 200) {
                    this.summaryData = res.data || {};
                    this.getBarData(this.summaryData.trend_data, "应收待确认汇总金额统计", "container1");
                }
            });
        },
        // 订单回款应收统计
        getOrderRepaySummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            OrderRepaySummary(params).then((res) => {
                if (res.code === 200) {
                    this.receivable_orderRefund_summaryData = res.data || {};
                    this.getBarData(
                        this.receivable_orderRefund_summaryData.trend_data,
                        "订单回款待确认总金额",
                        "container3"
                    );
                }
            });
        },
        // 采购退款应收统计
        getPurchaseRefundSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            PurchaseRefundSummary(params).then((res) => {
                if (res.code === 200) {
                    this.receivable_purchase_summaryData = res.data || {};
                    this.getBarData(
                        this.receivable_purchase_summaryData.trend_data,
                        "采购退款待确认总金额",
                        "container4"
                    );
                }
            });
        },
        // 未回款统计
        getUnpaidSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                // date_range: this.searchForm.date_range,
            };
            UnpaidSummary(params).then((res) => {
                if (res.code === 200) {
                    this.receivable_unRefund_summaryData = res.data || {};
                    this.getBarData(this.receivable_unRefund_summaryData.trend_data, "未回款总金额", "container5");
                }
            });
        },
        // 坏账统计数据
        getBadDebtSummary() {
            const params = {
                keyword: this.searchForm.keyword,
                date_range: this.searchForm.date_range,
            };
            BadDebtSummary(params).then((res) => {
                if (res.code === 200) {
                    this.receivable_badDebt_summaryData = res.data || {};
                    this.getBarData(this.receivable_badDebt_summaryData.trend_data, "坏账总金额", "container6");
                }
            });
        },
        getBarData(data, tooltipName, chartId) {
            let xData = data.map((item) => item.operate_date);
            let sData = data.map((item) => item.total_amount);

            var charts = document.getElementById(chartId);
            var myChart = echarts.getInstanceByDom(charts);
            if (myChart) {
                myChart.dispose();
            }
            this.getEchartsBar(chartId, xData, sData, tooltipName);
        },
        getEchartsBar(id, xData, sData, tooltipName) {
            var dom = document.getElementById(id);
            this["myChartBar" + id] = echarts.init(dom);
            this["myChartBar" + id].clear();
            var color = ["#1890ff", "#52C41B", "#FBAD13", "#FF4D4F", "#00BAAD"];
            var option;
            option = {
                color,
                grid: {
                    left: "10px",
                    top: "10px",
                    right: "10px",
                    bottom: "0",
                    containLabel: true,
                },
                tooltip: {
                    trigger: "item",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
                    },
                    triggerOn: "mousemove", // 鼠标移动时触发 tooltip
                    enterable: true,
                    zIndex: 1000, // 提高 tooltip 的层级
                    backgroundColor: "#fffffff",
                    padding: 12,
                    position: function (point, params, dom, rect, size) {
                        return [point[0], point[1]];
                    },
                    formatter: function (params) {
                        let html = `<div class="custom_chart_tooltip"><p class="tooltip_title">${params.name
                            }</p><p class="tooltip_content"><span>${tooltipName}</span><span class="count">${params.data + "元"
                            }</span></p></div>`;
                        return html;
                    },
                },
                dataZoom: [
                    {
                        type: 'slider', // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                        bottom: 0,
                        height: 15,
                        handleSize: '100%', // 滑块手柄的大小
                        handleStyle: {
                            color: '#000',
                            shadowBlur: 3,
                            shadowColor: 'rgba(0, 0, 0, 0.6)',
                            shadowOffsetX: 2,
                            shadowOffsetY: 2
                        }
                    },
                    {
                        type: 'inside', // 使用滑块类型
                        start: 0, // 初始化滑块开始位置（百分比）
                    }
                ],
                xAxis: {
                    type: "category",
                    data: xData,
                    axisLabel: {
                        interval: 0,
                        rotate: 0,
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "#000000FF",
                    },
                },
                yAxis: {
                    type: "value",
                    name: "", // 设置 y 轴标题
                    min: 0, // 设置最小值
                    scale: true, // 允许动态缩放
                    axisLine: {
                        show: false,
                    },
                    splitLine: {},
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: "rgba(0,0,0,.45)",
                        formatter: function (value) {
                            return value + "元";
                        },
                    },
                },
                series: [
                    {
                        data: sData,
                        type: "bar",
                    },
                ],
            };
            if (option && typeof option === "object") {
                this["myChartBar" + id].setOption(option, true);
            }
            // this.handleResize();
            // window.addEventListener("resize", this.handleResize);
        },
        // toTenThousand(value) {
        //     const wan = value / 10000;
        //     // 检查是否为整数
        //     if (wan % 1 === 0) {
        //         return wan;
        //     } else {
        //         // 可能需要保留两位小数，但去掉末尾的零
        //         let fixed = wan.toFixed(2);
        //         // 去掉末尾的零和小数点
        //         fixed = fixed.replace(/\.?0+$/, "");
        //         return fixed;
        //     }
        // },
        getPieData(list, chartId) {
            let sData = [];
            let sData2 = [];
            const color = [
                "#2990FF",
                "#F0AA32",
                "#5AB333",
                "#16ABA1",
                "#2E7DD9",
                "#9ECF36",
                "#DEAC07",
                "#E44144",
                "#A522BD",
                "#7143DE",
            ];
            list.forEach((item, index) => {
                const s_item = {
                    name: item.source_name + "总金额",
                    value: item.total_amount,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        // alignTo: "edge",
                        position: "outside",
                        formatter: `{circle|c}{name|{b}}\n{count|${item.total_amount}元}\n`,
                        labelLine: {
                            length: 20,
                        },

                        rich: {
                            count: {
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.45)",
                                padding: [0, 0, 0, 11],
                            },
                            name: {
                                padding: [0, 0, 0, 5],
                                fontSize: 12,
                                color: "rgba(0, 0, 0, 0.65)",
                            },
                            circle: {
                                width: 6,
                                height: 6,
                                backgroundColor: color[index],
                                borderRadius: 5,
                                color: "rgba(255,255,255,0)",
                            },
                        },
                    },
                };
                const s_item2 = {
                    name: item.source_name + "总金额",
                    value: item.total_amount,
                    color: color[index],
                    rate: item.rate,
                    label: {
                        normal: {
                            show: true,
                            position: "inner", // 数值显示在内部
                            formatter: "{d}%",
                            color: "#ffffff",
                        },
                    },
                };
                sData.push(s_item);
                sData2.push(s_item2);
            });
            this.getEchartsPie(chartId, sData, sData2, color);
        },
        getEchartsPie(id, sData, sData2, color) {
            var dom = document.getElementById(id);
            var myChart = echarts.init(dom);
            myChart.clear();
            var option;
            var that = this;
            option = {
                color,
                title: {
                    text: "",
                },
                tooltip: {
                    trigger: "item",
                    backgroundColor: "#fffffff",
                    padding: 12,
                    formatter: function (params) {
                        let html = "";
                        html += `<div class="custom_chart_tooltip"><p class="tooltip_title"><span>${params.name}</span></p><p class="tooltip_content"><span class="chart_circle_item"><i class="chart_circle" style="background: ${params.color}"></i>${params.value}元</span><span class="count">${params.percent}%</span></p></div>`;
                        return html;
                    },
                },
                legend: {
                    show: false,
                    icon: "rect",
                    itemWidth: 10,
                    itemHeight: 8,
                    borderRadius: 2,
                    textStyle: {
                        fontSize: 14, // 设置图例文本的字体大小为 16 像素
                        padding: [5, 0, 5, 0],
                    },
                    left: 0,
                    itemGap: 10,
                    top: 0,
                },
                left: "center",
                top: 35,
                right: 0,
                left: 0,
                bottom: 0,
                series: [
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 60,
                        top: 10,
                        labelLine: {
                            // length: 25,
                            // length2: 100,
                            // maxSurfaceAngle: 80,
                            showAbove: true,
                            lineStyle: {
                                color: "rgba(0, 0, 0, 0.25)",
                            },
                        },
                        // labelLayout: function (params) {
                        //     const isLeft = params.labelRect.x < myChart.getWidth() / 2;
                        //     const points = params.labelLinePoints;
                        //     // Update the end point.
                        //     points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params.labelRect.width;
                        //     return {
                        //         labelLinePoints: points,
                        //     };
                        // },
                        data: sData,
                    },
                    {
                        name: "",
                        type: "pie",
                        avoidLabelOverlap: true,
                        radius: 60,
                        top: 10,
                        data: sData2,
                    },
                ],
            };
            option && myChart.setOption(option, true);
            this.myChartPie = myChart;
            // this.handleResizePie();
            // window.addEventListener("resize", this.handleResizePie);
        },
        handleResize() {
            // if (this.resizeHandler) {
            //     clearTimeout(this.resizeHandler);
            // }
            // this.resizeHandler = setTimeout(() => {
            //     if (this.myChartBar) {
            //         this.myChartBar.resize();
            //     }
            // }, 100);
        },
        // 卡片编辑
        handleClickCardEdit() {
            this.isCardEdit = true;
        },
        // 卡片添加
        handleClickCardAdd() {
            this.setPopupVisible = true;
        },
        // 卡片编辑完成
        handleClickCardEditFinish() {
            this.isCardEdit = false;
            this.setPopupVisible = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.returnNavBarRight {
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 22px;
    color: rgba(41, 144, 255, 1);
}

.card_edit_btn {
    padding: 0 0 10px 0;
    display: flex;
    justify-content: space-between;

    .van-button {
        width: 64px;
        height: 26px;
        border-radius: 6px;
        font-size: 14px;
    }

    .van-button--default {
        background: rgba(204, 204, 204, 0.5);
        color: rgba(51, 51, 51, 1);
    }

    .van-button--info {
        background-color: rgba(42, 130, 228, 0.1);
        border-color: rgba(42, 130, 228, 0.1);
        color: rgba(42, 130, 228, 1);
    }
}

.card_item {
    position: relative;

    .card_item_mark {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.3);
        box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.07);

        .iconfont {
            position: absolute;
            top: -8px;
            right: -8px;
            color: rgba(191, 191, 191, 1);
        }
    }
}

.finance_management_container {
    width: 100%;
    padding: 10px 16px;
    box-sizing: border-box;
    overflow-x: hidden;

    .finance_top_card {
        ul {
            display: flex;
            gap: 7px;

            li {
                flex: 1;
                height: 84px;
                opacity: 1;
                padding: 7px 10px;
                border-radius: 6px;
                box-shadow: 0px 1px 2px #00000011;
                box-sizing: border-box;
                background-size: 100% 100%;
                background-repeat: no-repeat;

                p:nth-child(1) {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(153, 153, 153, 1);
                    display: flex;
                    align-items: center;
                    gap: 4px;

                    img {
                        width: 16px;
                    }
                }

                p:nth-child(2) {
                    margin: 2px 0;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }

                p:nth-child(3) {
                    font-size: 14px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 22px;
                }

                &:nth-child(1) {
                    background-image: url("https://download.hecoos.com/enlightv/2025-06/66f91875faef1b3df5fe59b885057566.png");

                    p:nth-child(3) {
                        color: #f0aa32ff;
                    }
                }

                &:nth-child(2) {
                    background-image: url("https://download.hecoos.com/enlightv/2025-06/239bbb35155d9cbd2a8a6ec492f4098e.png");

                    p:nth-child(3) {
                        color: #2990f0ff;
                    }
                }

                &:nth-child(3) {
                    background-image: url("https://download.hecoos.com/enlightv/2025-06/d3994ef252e716ea2ac66083fc286c67.png");

                    p:nth-child(3) {
                        color: #6aba47ff;
                    }
                }
            }
        }
    }

    .finance_filter {
        margin: 10px 0;
        height: 22px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .finance_filter_left {
            span {
                display: inline-block;
                vertical-align: top;
                width: 68px;
                height: 22px;
                text-align: center;
                line-height: 22px;
                font-size: 12px;
                font-weight: 400;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);
                border-radius: 6px;
                background: rgba(102, 102, 102, 0.04);

                &.active {
                    font-weight: 700;
                    color: rgba(42, 130, 228, 1);
                    background: rgba(236, 244, 252, 1);
                }

                &+span {
                    margin-left: 10px;
                }
            }
        }

        .finance_filter_right {
            span {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
            }

            i {
                margin-left: 8px;
                color: rgba(102, 102, 102, 1);
            }
        }
    }

    .finance_statistics_num {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 4px;

        li {
            display: inline-block;
            width: calc(50% - 4px);
            height: 88px;
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.07);
            box-sizing: border-box;
            padding-top: 16px;
            background: url("https://download.hecoos.com/enlightv/2025-06/53a62576bce55d4ee20e556090a096d3.png") no-repeat;
            background-size: 100% 100%;

            p {
                text-align: center;
            }

            p:nth-child(1) {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }

            p:nth-child(2) {
                margin-top: 10px;
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(41, 144, 240, 1);
            }
        }
    }

    .chart_box {
        margin: 10px 0;
        width: 100%;
        height: 176px;
        border-radius: 6px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 2px 1px 2px rgba(0, 0, 0, 0.07);
        padding-top: 10px;

        .chart_box_time_type {
            padding-right: 10px;
            height: 22px;
            display: flex;
            justify-content: flex-end;
            gap: 8px;

            span {
                width: 28px;
                height: 22px;
                text-align: center;
                line-height: 22px;
                opacity: 1;
                border-radius: 6px;
                background: rgba(243, 243, 243, 1);

                &.active {
                    background: rgba(221, 237, 255, 1);
                    color: rgba(42, 130, 228, 1);
                }
            }
        }

        .echarts_container {
            width: 100%;
            height: calc(100% - 32px);
        }

        &.pie_chart_box {
            padding-top: 0;

            .echarts_container {
                width: 100%;
                height: calc(100%);
            }
        }
    }
}

.set_popup {
    border-radius: 6px 6px 0px 0px;

    .set_popup_wrap {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .set_popup_content {
            flex: 1;
            overflow-y: auto;
            padding: 0 16px;
        }
    }

    .set_popup_title {
        padding: 10px 16px;
        display: flex;
        align-items: center;
        gap: 12px;

        .van-search {
            flex: 1;
            padding: 0;

            .van-search__content {
                background-color: rgba(243, 243, 243, 1);
                border-radius: 6px;
            }

            .van-cell {
                padding: 4px 8px 4px 0;
            }

            ::v-deep {
                .van-field__left-icon {
                    color: rgba(51, 51, 51, 1);
                }
            }
        }

        .van-button {
            height: 32px;
            padding: 0;
            border: 0;
            color: rgba(42, 130, 228, 1);
        }
    }

    .set_popup_card {
        margin-bottom: 16px;

        .set_item_title {
            position: relative;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(0, 0, 0, 1);
            padding-bottom: 4px;

            &::after {
                content: "";
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
                height: 1px;
                border-radius: 1px;
                background-color: rgba(204, 204, 204, 0.2);
            }
        }

        ul {
            padding-top: 10px;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 4px;

            li {
                width: calc(50% - 4px);
                height: 76px;
                border-radius: 6px;
                background: rgba(41, 144, 255, 0.04);
                margin-bottom: 6px;
                padding: 10px;
                box-sizing: border-box;
                background-repeat: no-repeat;

                &>p {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                    margin-bottom: 8px;
                }

                .card_item_btn {
                    display: block;
                    width: 44px;
                    height: 26px;
                    opacity: 1;
                    border-radius: 4px;
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    text-align: center;
                    line-height: 26px;
                }
            }
        }

        &.set_popup_card_added {
            padding-top: 10px;

            ul {
                li {
                    background: url("https://download.hecoos.com/enlightv/2025-06/53a62576bce55d4ee20e556090a096d3.png") no-repeat;
                    background-size: 100% 100%;

                    .card_item_btn {
                        background-color: rgba(41, 144, 255, 0.1);
                        color: rgba(41, 144, 255, 1);
                    }
                }
            }
        }

        &.set_popup_card_un_add {
            ul {
                li {
                    background: url("https://download.hecoos.com/enlightv/2025-06/53a62576bce55d4ee20e556090a096d3.png") no-repeat;
                    background-size: 100% 100%;

                    .card_item_btn {
                        background-color: rgba(236, 246, 231, 1);
                        color: rgba(106, 186, 71, 1);
                    }
                }
            }
        }

    }
}
</style>
<style lang="scss">
.custom_chart_tooltip {
    background-color: #ffffff;
    padding: 12px;
    border-radius: 2px;
    box-shadow: 0px 2px 4px #0000003f;

    .tooltip_title {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.45);
    }

    .tooltip_content {
        margin-top: 12px;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.2px;
        line-height: 12px;
        color: rgba(0, 0, 0, 0.65);
        display: flex;
        justify-content: space-between;
        gap: 24px;

        .count {
            font-weight: 500;
        }

        .chart_circle_item {
            display: flex;
            align-items: center;

            .chart_circle {
                display: inline-block;
                vertical-align: middle;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                margin-right: 9px;
            }
        }
    }
}
</style>
